export default __webpack_public_path__ + "static/media/about-bg.09ef7c92.png";